let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7UntI")).then(() => parcelRequire('6DFbP'));